import React from 'react';
import { useNavigate } from 'react-router';
import { MdWifiOff } from 'react-icons/md';

export default function Offline() {
    const navigate = useNavigate();

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
            padding: '0 24px 32px',
            background: '#111',
            color: '#fff',
            textAlign: 'center',
            gap: 0,
            overflowY: 'auto',
        }}>
            {/* Icon */}
            <MdWifiOff style={{ fontSize: 64, color: '#ffcc00', marginBottom: 20 }} />

            <h2 style={{ margin: '0 0 8px', fontSize: '1.2rem', fontWeight: 800, color: '#fff' }}>
                You're Offline
            </h2>
            <p style={{ margin: '0 0 28px', fontSize: '0.82rem', color: 'rgba(255,255,255,0.5)', lineHeight: 1.5, maxWidth: 340 }}>
                This feature needs an internet connection. Your previously loaded data is still available.
            </p>

            {/* Info card */}
            <div style={{
                width: '100%',
                maxWidth: 420,
                background: 'rgba(255,204,0,0.07)',
                border: '1px solid rgba(255,204,0,0.2)',
                borderRadius: 14,
                padding: '14px 18px',
                marginBottom: 28,
                textAlign: 'left',
            }}>
                <p style={{ margin: '0 0 6px', fontSize: '0.78rem', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.05em', color: '#ffcc00' }}>
                    Available offline
                </p>
                <ul style={{ margin: 0, padding: '0 0 0 18px', fontSize: '0.82rem', color: 'rgba(255,255,255,0.85)', lineHeight: 1.7 }}>
                    <li>Browsing receipts &amp; reports</li>
                    <li>Viewing merchants &amp; brands</li>
                    <li>Searching cached data</li>
                </ul>
            </div>

            <div style={{ display: 'flex', gap: 12, width: '100%', maxWidth: 420 }}>
                <button
                    style={{
                        flex: 1,
                        background: 'rgba(255,255,255,0.08)',
                        color: 'rgba(255,255,255,0.7)',
                        border: 'none',
                        borderRadius: 12,
                        padding: 13,
                        fontSize: '0.85rem',
                        fontWeight: 700,
                        cursor: 'pointer',
                        fontFamily: 'inherit',
                    }}
                    onClick={() => navigate(-1)}
                >
                    Go Back
                </button>
                <button
                    style={{
                        flex: 2,
                        background: '#ffcc00',
                        color: '#111',
                        border: 'none',
                        borderRadius: 12,
                        padding: 13,
                        fontSize: '0.85rem',
                        fontWeight: 800,
                        cursor: 'pointer',
                        fontFamily: 'inherit',
                    }}
                    onClick={() => window.location.reload()}
                >
                    Try Again
                </button>
            </div>

            <p style={{ marginTop: 20, fontSize: '0.78rem', color: 'rgba(255,255,255,0.35)' }}>
                Some features may be limited while offline
            </p>
        </div>
    );
}
